export const validateUrl = (value, field) => {
  // eslint-disable-next-line no-useless-escape
  const regex = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/

  return regex.test(value)
}
